import BaseApi from "./BaseApi";

class CandidateApi extends BaseApi {
  constructor() {
    super("candidates");
  }
}

export default CandidateApi;
